// extracted by mini-css-extract-plugin
export default {"fullscreenLoader":"FullscreenLoader_fullscreenLoader__qG4H2"};